import {  deleteRequestDelegationAction } from "../deleteDelegation.action";
import {$api} from "../../../../../services/request.config";

export const deleteRequestDelegationThunkAction = ({id, statusModal, setStatusModal}) => async (dispatch) => {
    try {
        const response = await $api.delete(`v1/manager/delegations/${id}`);
        // console.log("RESPONSE DELETE: ", response)
        if (response.status === 204) {
            dispatch(deleteRequestDelegationAction(id));
            setStatusModal({status: false, loading: false,  message: "", delete: false});
        }
    } catch (error) {
        setStatusModal({...statusModal, loading: false});
        if (error.response.status === 404) {
            return     setStatusModal({delete: false, status: true, loading: false, message: "Делегирование не найдено"});
        }else if (error.response.status === 422) {
            return  setStatusModal({delete: false, status: true, loading: false, message: `${error.response.data.detail}`});
        } else {
            return     setStatusModal({delete: false, status: true, loading: false, message: "Ошибка при удалении делегирования"});
        }
        // console.log("ERROR WHILE DELETING REPLACEMENT: ", error.response)
    }
};
